module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "section"
  }, [(_vm.playlist) ? _c('div', {
    staticClass: "container"
  }, [_c('div', [_c('h1', {
    staticClass: "title"
  }, [_vm._v("\n          " + _vm._s(_vm.playlist.name) + "\n        ")]), _vm._v(" "), _c('h2', {
    staticClass: "subTitle"
  }, [_vm._v("\n          " + _vm._s("items:") + "\n        ")]), _vm._v(" "), _c('draggable-playlist-items', {
    on: {
      "itemClick": function($event) {
        return _vm.showPlaylistItem($event)
      }
    }
  })], 1)]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-65f5509e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PlaylistShow.vue
// module id = 318
// module chunks = 2